import React from 'react';
import './AnalyticsPage.css';

const AnalyticsPage: React.FC = () => {
  return (
    <div className="analytics-page" data-testid="analytics-page">
      <h1 className="analytics-page__title">Аналитика</h1>
      <div className="analytics-page__placeholder">
        <p className="analytics-page__text">Раздел в разработке</p>
        <p className="analytics-page__subtext">Здесь будут аналитические данные и отчеты</p>
      </div>
    </div>
  );
};

export default AnalyticsPage;
